import { render, staticRenderFns } from "./BloodPressList.vue?vue&type=template&id=216bb39b&scoped=true"
import script from "./BloodPressList.vue?vue&type=script&lang=js"
export * from "./BloodPressList.vue?vue&type=script&lang=js"
import style0 from "./BloodPressList.vue?vue&type=style&index=0&id=216bb39b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216bb39b",
  null
  
)

export default component.exports